import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Join</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/(auth)/join-or-sign-in" dismiss />
    </ExpoRouterDemoScreen>
  );
}
